export default function ReadyMixColours() {
    document.querySelectorAll("[data-ready-mix-colours]").forEach(setupGrid);
}

function setupGrid(container) {
    const tabs = container.querySelectorAll("[data-rmx-filter]");
    const items = container.querySelectorAll("[data-rmx-category]");

    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const filter = tab.getAttribute("data-rmx-filter");

            tabs.forEach((other) => {
                const isActive = other === tab;
                other.classList.toggle("is-active", isActive);
                other.setAttribute("aria-pressed", isActive ? "true" : "false");
            });

            items.forEach((item) => {
                const show = filter === "all" || item.getAttribute("data-rmx-category") === filter;
                item.toggleAttribute("hidden", !show);
            });
        });
    });
}
